import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import {ReactBaseComponent} from '../../../react/base/react-base.component';
import {ArticleStepsCopyButton} from '../../../react/article/steps/article-steps-copy-button';
import {Article} from '../models/article.models';

const containerElementName = 'reactArticleProductionStepCopy';

@Component({
  selector: 'article-production-step-copy-react',
  template: `<div #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ArticleProductionStepCopyReactComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() article: Article;
  @Output() updateList: EventEmitter<void> = new EventEmitter<void>();

  constructor(private ngZone: NgZone) {
    super();
  }

  update(): void {
    this.ngZone.run(() => {
      this.updateList.emit();
    });
  }

  protected override renderComponent() {
    return <ArticleStepsCopyButton article={this.article} updateList={() => this.update()} />;
  }
}
